import React from 'react';
import { SellerChangeRequestStatus } from '@/types';
import { BaseStatusIndicatorProps } from '.';
import { IndicatorColor } from '@/components/Indicator';
import {
    faExclamation,
    faQuestion,
    faCheck,
    faArrowRight,
    faTimes,
    faMinus,
    IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { IconIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { useLingui } from '@lingui/react';

interface ChangeRequestStatusIndicatorProps extends BaseStatusIndicatorProps {
    value: SellerChangeRequestStatus;
}

const sellerColorMap: { [key in SellerChangeRequestStatus]: IndicatorColor } = {
    Unassigned: 'danger',
    AwaitingOffers: 'warning',
    ReadyToSend: 'warning',
    SentToBuyer: 'warning',
    AcceptedByBuyer: 'success',
    // AcceptedBySeller : 'success',
    Rejected: 'danger',
    Closed: 'secondary',
    CanceledBySeller: 'danger',
    Archived: 'secondary',
};

const sellerIconMap: { [key in SellerChangeRequestStatus]: IconDefinition | null } = {
    Unassigned: faExclamation,
    AwaitingOffers: faQuestion,
    ReadyToSend: faCheck,
    SentToBuyer: faArrowRight,
    AcceptedByBuyer: faCheck,
    // AcceptedBySeller : 'success',
    Rejected: faTimes,
    Closed: faMinus,
    CanceledBySeller: faTimes,
    Archived: null,
};

const ChangeRequestStatusIndicator: React.FC<ChangeRequestStatusIndicatorProps> = ({ value, children, ...rest }) => {
    const { _ } = useLingui();

    return (
        <IconIndicator icon={sellerIconMap[value] ?? undefined} color={sellerColorMap[value]} {...rest}>
            {children || _({ id: `ChangeRequestStatus.${value}` })}
        </IconIndicator>
    );
};

export default ChangeRequestStatusIndicator;
